import './bootstrap'
import router from './routes'
import App from './components/App'
import './services/filters'
import store from './stores/store'
import "./services/middlewares"
import "./services/directives"

const app = new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App />'
})
